import request from '@/utils/request'

const portalApi = process.env.VUE_APP_PORTAL_API
const passportApi = process.env.VUE_APP_PASSPORT_API

// 获取服务器系统时间
export function getTimeMillisApi() {
  return request({
    url: portalApi + '/common/time-millis',
    method: 'get'
  })
}

/**
 * 获取标前狗租户配置
 */
export function getTenantConfigApi(domain) {
  return request({
    url: `${passportApi}/tenants/biddog/detail`,
    method: 'get',
    params: { domain }
  })
}

/**
 * 获取当前租户各平台的域名
 */
export function getTenantPlatformDomainApi(tenantId) {
  return new Promise((resolve, reject) => {
    Promise.all([
      request({
        url: `${passportApi}/tenants/${tenantId}/domain`,
        method: 'get'
      }),
      request({
        url: `${passportApi}/tenants/default/domain`,
        method: 'get'
      })
    ])
      .then((result) => {
        resolve({ data: { ...result[1].data, ...result[0].data } })
      })
      .catch((err) => {
        reject(err)
      })
  })
}
